<template>
    <div
        :class="{ [`l-ss-c-filter-color-${filter.name}`]: true, 'l-ss-c-filter-is-short': isShort }"
        class="l-ss-c-filter-color">
        <c-label
            v-if="showTitle"
            :label="filterLabel"/>

        <div class="l-ss-c-filter-color-group-wrapper">
            <div
                class="l-ss-c-filter-color-group">
                <div
                    v-for="option in optionsIndex"
                    class="l-ss-c-filter-color-option"
                    :class="{ 'l-ss-c-filter-color-option-is-active': isChecked(option.id) }"
                    :key="`filter-${option.id}-${isChecked(option.id)}`"
                    @click="onToggle(option.id)">
                    <span
                        class="l-ss-c-filter-color-option-color-box"
                        :style="`background-color:${option.name}`"></span>
                    <span
                        class="l-ss-c-filter-color-option-counter"
                        v-if="option.hits">{{ option.hits }}</span>
                </div>
            </div>
        </div>
        <div
            v-if="hasShowMore"
            class="l-ss-c-navigation-list-item-actions">
            <button
                v-if="showMore"
                class="l-ss-c-button"
                @click="() => showMore=false">
                {{ $t('navigation.showLess') }}
            </button>
            <button
                v-else
                class="l-ss-c-button"
                @click="() => showMore=true">
                {{ $t('navigation.showMore') }}
            </button>
        </div>
    </div>
</template>

<script>
    import FilterMixin from './mixin';
    import CLabel from './components/label';

    const MIN_ITEMS_COUNT_FOR_SHOW_MORE = 3;

    export default {
        components: {
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
        props: {},
        data() {
            return {
                values: [],
                showMore: false,
            };
        },
        computed: {
            hasShowMore() {
                return !this.forceShowAll && this.filter.options.length >= MIN_ITEMS_COUNT_FOR_SHOW_MORE;
            },
            optionsIndex() {
                return this.filter.options
                    .slice(0)
                    .map(item => ({
                        ...item,
                        searchIndex: item.name.toLowerCase(),
                    }));
            },
        },
        mounted() {
            const options = this.options || [];
            if (this.values.length && !this.values.every(optionId => options.find(item => item.id === optionId))) {
                this.showMore = true;
            }
        },
        methods: {
            isChecked(optionId) {
                return this.values.includes(optionId);
            },
            onToggle(value) {
                this.values = [value];
                const values = this.values.slice(0);
                if (values.length) {
                    this.onChange({
                        condition: 'in',
                        options: values.slice(0),
                    });
                } else {
                    this.onChange();
                }
            },
        },
    };
</script>